const API_URL = "http://localhost:8080"

export {API_URL}
